import 'reflect-metadata';

import { Container } from 'inversify';

import { InversifyContainer } from '../../shared/abstract/infrastructrue/Inversify.container';
import { UserPrincipalUIService } from './application/UserPrincipal.ui.service';
import { UserPrincipalAdapter } from './infrastructure/adapters/UserPrincipal.adapter';
import { UserPrincipalUIController } from './infrastructure/controllers/UserPrincipal.ui.controller';
import { UserPrincipalComponentFactory } from './infrastructure/factories/UserPrincipal.component.factory';
import { LogoutCardComponent } from './infrastructure/ui/LogoutCard/LogoutCard.component';

export class UserPrincipalDomainContainer extends InversifyContainer {
  static create(): Container {
    return this.buildInversifyIOCContainer([
      LogoutCardComponent,
      UserPrincipalAdapter,
      UserPrincipalUIController,
      UserPrincipalUIService,
      UserPrincipalComponentFactory,
    ]);
  }
}
